import React, { useEffect, useLayoutEffect } from "react";

import { useTranslation } from "react-i18next";

import { isGamesTheme, setTabTitle } from "@utils";
import ReactMarkdown from "react-markdown";
import { THEME_SETTINGS } from "@theme-settings";
import { useRootAppStore } from "@hooks";
import { MobilePlatform } from "@state/stores/types";
import { useScrollRestoration } from "@hooks/useScrollRestoration";
import { ConfigType } from "@data-types/use-scroll-restoration/useScrollRestoration";

export const GamingRisksPage = () => {
	const { t } = useTranslation();

	const { pageStore } = useRootAppStore<MobilePlatform>();

	useScrollRestoration({ type: ConfigType.Basic });

	useEffect(() => {
		setTabTitle(t("GAMING_RISKS.TITLE"));
	}, []);

	useLayoutEffect(() => {
		pageStore.setSubPageHeader({
			title: t("GAMING_RISKS.TITLE"),
		});
	}, []);

	return (
		<div className="container container--base">
			<div className="card card--legal">
				{THEME_SETTINGS.licensingIcons.includes("ggl") && (
					<div className="card--legal__thumb">
						<a
							href="https://www.gluecksspiel-behoerde.de/de/"
							className="card--legal__link"
							rel="nofollow"
							title="GGL"
							target="_blank"
						>
							<i className="u-icon u-icon--ggl card--legal__icon" />
						</a>
					</div>
				)}
				{!isGamesTheme() && (
					<div className="card--legal__content">
						<div className="card--legal__inline">
							<span className="u-mar--right--micro u-type--wgt--bold">
								{t<string>("FOOTER.WARNING_LABEL")}
							</span>
							<ReactMarkdown
								linkTarget={"blank"}
								className="u-anchor--nested"
							>
								{t("specific:GAMING_RISKS.WARNING_TEXT")}
							</ReactMarkdown>
						</div>
					</div>
				)}
				{isGamesTheme() && (
					<div className="card--legal__content">
						<div className="card--legal__inline">
							<span className="u-mar--right--micro u-type--wgt--bold">
								{t<string>("FOOTER.WARNING_LABEL")}
							</span>
							<ReactMarkdown
								linkTarget={"blank"}
								className="u-anchor--nested"
							>
								{t("FOOTER.WARNING_TEXT_GAMES")}
							</ReactMarkdown>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};
